import React, { useEffect, useRef } from "react";

import { useFullscreen } from "@mantine/hooks";
import { useAppState } from "Context/StateContext";
import ReactDOM from "react-dom";
import { Toaster as ToasterRHT } from "react-hot-toast";

import { getMuiPopupContainer } from "../../../container/themes/dispatchTheme";

export const Toaster = () => {
  const { currentUser } = useAppState();

  const bodyRef = useRef<Element | null>();
  const { fullscreen: isFullscreen } = useFullscreen();

  useEffect(() => {
    bodyRef.current = getMuiPopupContainer();
  }, [isFullscreen]);

  if (!bodyRef.current) return null;

  return (
    <>
      {ReactDOM.createPortal(
        <div>
          <ToasterRHT
            containerStyle={{
              marginBottom: "20px",
              marginRight: "20px",
            }}
            toastOptions={{
              duration: 2000,
              position: "top-right",
            }}
          />
        </div>,
        bodyRef.current
      )}
    </>
  );
};
